<template>
  <div>
    <section class="content-header show-print">
      <h1 v-if="item">{{ item.title }}</h1>
    </section>

      <section class="content">
        <div class="box box-primary">
          <div class="box-body">
          <item-show-errors entity="post" :is-loading="isLoading"></item-show-errors>

            <div v-if="item" class="table-responsive">
              <table class="table table-striped table-hover">
                <thead>
                <tr>
                  <th width="20%">{{ $t('field') }}</th>
                  <th>{{ $t('value') }}</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td>{{ $t('post.id') }}</td>
                  <td>{{ item.id }}</td>
                </tr>
                <tr>
                  <td>{{ $t('post.title') }}</td>
                  <td>{{ item.title }}</td>
                </tr>
                <tr>
                  <td>{{ $t('post.summary') }}</td>
                  <td>{{ item.summary }}</td>
                </tr>
                <tr>
                  <td>{{ $t('post.description') }}</td>
                  <td>{{ item.description }}</td>
                </tr>
                <tr>
                  <td>{{ $t('post.createdAt') }}</td>
                  <td>{{ moment(item.createdAt).format('DD-MM-YYYY HH:mm') }}</td>
                </tr>
                <tr>
                  <td>{{ $t('post.updatedAt') }}</td>
                  <td>{{ moment(item.updatedAt).format('DD-MM-YYYY HH:mm') }}</td>
                </tr>
                <tr>
                  <td>{{ $t('post.updatedBy') }}</td>
                  <td>{{ item.updatedBy }}</td>
                </tr>
                <tr>
                  <td>{{ $t('post.images') }}</td>
                  <td>
                    <template v-for="image in item.images">
                      <img :src="imagePath(image, '200')" class="wp-post-image" alt="">
                    </template>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

      <item-show-actions :item="item" entity="Post" path="post"></item-show-actions>
    </section>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import ItemShowActions from '../layout/ItemShowActions'
import ItemShowErrors from '../layout/errors/ItemShowErrors'
import Image from '../../mixin/Image'

export default {
  mixins: [Image],

  components: {
    ItemShowErrors,
    ItemShowActions
  },
  data () {
    return {
      moment: moment
    }
  },
  computed: {
    ...mapGetters({
      isLoading: 'post/show/isLoading',
      item: 'post/show/retrieved',
    })
  },

  beforeDestroy () {
    this.reset()
  },

  created () {
    this.retrieve(decodeURIComponent(this.$route.params.id))
  },

  methods: {
    ...mapActions({
      reset: 'post/show/reset',
      retrieve: 'post/show/retrieve',
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/post/Show.vue